import GlobalMessage from './globalMessage'

export const GlobalMessageProvider = GlobalMessage.Provider
const useGlobalMessage = GlobalMessage.useContainer
export default useGlobalMessage
